import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome } from 'react-icons/fi';

const NotFound = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '20px'
    }}>
      <h1 style={{ fontSize: '72px', marginBottom: '20px' }}>404</h1>
      <h2 style={{ marginBottom: '10px' }}>Halaman Tidak Ditemukan</h2>
      <p style={{ color: 'var(--text-secondary)', marginBottom: '30px' }}>
        Maaf, halaman yang Anda cari tidak ditemukan.
      </p>
      <Link to="/dashboard" className="btn btn-primary">
        <FiHome /> Kembali ke Dashboard
      </Link>
    </div>
  );
};

export default NotFound;
